import { render, staticRenderFns } from "./TodoSalesOrder.vue?vue&type=template&id=0f7e5c43&scoped=true&"
import script from "./TodoSalesOrder.vue?vue&type=script&lang=js&"
export * from "./TodoSalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e5c43",
  null
  
)

export default component.exports